<p-breadcrumb
  [model]="[
    { label: 'Transportadoras', routerLink: ['/carriers'] },
    {
      label: carrierId() ? 'Editar Transportadora' : 'Nova Transportadora',
      routerLink: carrierId()
        ? ['/carriers/update/' + carrierId()]
        : ['/carriers/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(carrierId()){
        <h5 class="font-bold">Editar Transportadora</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Nova Transportadora</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>

      <div class="flex justify-end gap-5 items-center">
        @if(carrierId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive" />
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }
        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/carriers"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="flex flex-wrap xl:flex-nowrap gap-5 mt-5">
    <div class="card space-y-5 w-full">
      <h5 class="font-bold">Informações gerais</h5>

      <div class="w-full">
        <label>Nome *</label>
        <input
          pInputText
          formControlName="name"
          class="w-full"
          placeholder="Informe o nome"
        />
        <app-form-error [control]="formGroup.get('name')" />
        <app-form-server-error [control]="formGroup.get('name')" />
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label>Website</label>
          <input
            pInputText
            formControlName="websiteUrl"
            class="w-full"
            placeholder="Informe o website da transportadora"
          />
          <app-form-error [control]="formGroup.get('websiteUrl')" />
          <app-form-server-error [control]="formGroup.get('websiteUrl')" />
        </div>

        <div>
          <label>Link de rastreamento</label>
          <input
            pInputText
            formControlName="trackingUrl"
            class="w-full"
            placeholder="Informe o link de rastreamento dos pedidos na transportadora"
          />
          <app-form-error [control]="formGroup.get('trackingUrl')" />
          <app-form-server-error [control]="formGroup.get('trackingUrl')" />
        </div>
      </div>
    </div>
  </div>

  @if(loading()) {
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
  </div>
  }
</form>

<p-toast />
